import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import {store} from "./Store/store"
import './Assets/css/style.css'
import './Assets/css/responsivestyle.css'
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'video-react/dist/video-react.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<Provider store={store} >
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </Provider>
);